import React, { useEffect, useState } from 'react';
import DENTModalOverviewSubButtonsSelection from '../DENTModalOverviewSubButtonsSelection/DENTModalOverviewSubButtonsSelection';
import {
	ToothJaw,
	ToothPathologyApicalValues,
	ToothPresence,
	ToothRootSurface,
	ToothType,
} from '../../../../graphql/graphql';
import useTooth from '../../Hooks/Tooth/useTooth';
import { handleSurfacesOperation } from '../../Helpers/surfaces/toothSurfaces.helper';
import { SurfaceOperation } from '../../Enums/SurfaceOperation.enum';
import { useDENTContext } from '../../Services/DENTContext';

const DENTModalOverviewPathologyApical = () => {
	const { activeTooth } = useDENTContext();
	const {
		pathology: { apical },
	} = useTooth();

	const [values, setValues] = useState<ToothPathologyApicalValues | undefined>(
		apical.values,
	);

	useEffect(() => {
		if (values) apical.setValues(values);
	}, [values]);

	const handleChangePresence = (value: ToothPresence) =>
		setValues(prev => ({
			...prev,
			presence: prev?.presence === value ? undefined : value,
			rootsAffected:
				value === ToothPresence.No ? undefined : prev?.rootsAffected,
		}));

	const handleChangeRootsAffected = (value: ToothRootSurface) =>
		setValues(prev => {
			const currentRootsAffected = prev?.rootsAffected ?? [];
			const operation = currentRootsAffected.includes(value)
				? SurfaceOperation.REMOVE
				: SurfaceOperation.ADD;

			return {
				...prev,
				rootsAffected: handleSurfacesOperation(
					currentRootsAffected,
					[value],
					operation,
				),
			};
		});

	const rows = [
		{
			shouldHide: false,
			items: [
				{
					title: 'base.yes',
					isSelected: values?.presence === ToothPresence.Yes,
					onClick: () => handleChangePresence(ToothPresence.Yes),
				},
				{
					title: 'base.no',
					isSelected: values?.presence === ToothPresence.No,
					onClick: () => handleChangePresence(ToothPresence.No),
				},
			],
		},
		{
			shouldHide: !(
				values?.presence === ToothPresence.Yes &&
				activeTooth?.type === ToothType.Molar
			),
			items: [
				{
					title: 'patientTreatment.meddiDENT.dentalCross.surfaces.mesial',
					isSelected: !!values?.rootsAffected?.includes(
						ToothRootSurface.Mesial,
					),
					onClick: () => handleChangeRootsAffected(ToothRootSurface.Mesial),
				},
				...(activeTooth?.jaw === ToothJaw.Upper
					? [
							{
								title: 'patientTreatment.meddiDENT.dentalCross.surfaces.buccal',
								isSelected: !!values?.rootsAffected?.includes(
									ToothRootSurface.Buccal,
								),
								onClick: () =>
									handleChangeRootsAffected(ToothRootSurface.Buccal),
							},
					  ]
					: []),
				{
					title: 'patientTreatment.meddiDENT.dentalCross.surfaces.distal',
					isSelected: !!values?.rootsAffected?.includes(
						ToothRootSurface.Distal,
					),
					onClick: () => handleChangeRootsAffected(ToothRootSurface.Distal),
				},
			],
		},
	];

	return <DENTModalOverviewSubButtonsSelection rows={rows} />;
};

export default DENTModalOverviewPathologyApical;
